module.exports = __webpack_public_path__ + "img/logo-acdemy.e114831c.svg";